import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";

@Injectable()
export class SymbolTypeService {
    public subscriber: Subject<SymbolTypeEnum> = new Subject<SymbolTypeEnum>();
    public scanResultClick: Subject<any> = new Subject<any>();
    
}

